// Custom hand-drawn-style brand glyphs (thin line-art, matches the BloomHer rose logo).
const base = (className, style) => ({
  className,
  style,
  viewBox: "0 0 32 32",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  xmlns: "http://www.w3.org/2000/svg",
});

// Mood — a blooming sun/flower
export const MoodGlyph = ({ className = "h-6 w-6", style }) => (
  <svg {...base(className, style)} aria-hidden="true">
    <circle cx="16" cy="16" r="6" />
    <path d="M16 4v3M16 25v3M4 16h3M25 16h3M7.5 7.5l2 2M22.5 22.5l2 2M24.5 7.5l-2 2M9.5 22.5l-2 2" />
    <path d="M13.5 17a3 3 0 0 0 5 0" />
  </svg>
);

// Energy — a leaf with a spark vein
export const EnergyGlyph = ({ className = "h-6 w-6", style }) => (
  <svg {...base(className, style)} aria-hidden="true">
    <path d="M22 6C12 7 7 12 7 21c0 0 0 4 0 5 9 0 16-5 17-15 .3-3 0-5 0-5-2 0-2 0-2 0z" />
    <path d="M9 24C13 18 17 14 22 11" />
    <path d="M16 17l-2 3M16 14l3 0" />
  </svg>
);

// Sleep — crescent moon with stars
export const SleepGlyph = ({ className = "h-6 w-6", style }) => (
  <svg {...base(className, style)} aria-hidden="true">
    <path d="M21 22a9 9 0 1 1-7-15 7 7 0 0 0 7 15z" />
    <path d="M24 8l.8 2 2 .8-2 .8L24 13.6 23.2 11.6 21.2 10.8 23.2 10z" fill="currentColor" stroke="none" />
  </svg>
);

// Stress — flowing breath waves
export const StressGlyph = ({ className = "h-6 w-6", style }) => (
  <svg {...base(className, style)} aria-hidden="true">
    <path d="M5 12c3-2 5-2 8 0s5 2 8 0 3-2 5-1" />
    <path d="M5 18c3-2 5-2 8 0s5 2 8 0 3-2 5-1" />
    <path d="M5 24c3-2 5-2 8 0s5 2 8 0 3-2 5-1" />
  </svg>
);

// A small rose bud (reusable accent)
export const RoseGlyph = ({ className = "h-6 w-6", style }) => (
  <svg viewBox="0 0 50 70" className={className} style={style} fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M25 8 Q18 6 16 12 Q12 10 12 18 Q10 22 16 24 Q18 28 24 26 Q26 30 32 26 Q38 28 38 22 Q42 18 38 14 Q36 8 30 10 Q28 6 25 8 Z" />
    <circle cx="25" cy="18" r="1.2" fill="currentColor" stroke="none" />
    <path d="M25 28 Q25 40 25 60" />
    <path d="M25 42 Q19 41 17 45 Q22 47 25 44" />
  </svg>
);
